import { createSelector } from 'reselect';

const makeSelectDialogTrigger = () =>
  createSelector(
    (state) => state.get('dialogTriggers'),
    (substate) => substate && substate.toJS(),
  );

export default makeSelectDialogTrigger;
